import React from 'react';
import PropTypes from 'prop-types';

import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import Logo from 'dpl/components/Logo';
import SmartImage from 'dpl/components/SmartImage';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import { ModalPropTypes } from 'dpl/prismic/utils/customPropTypes';
import { isAllowedAccess } from 'dpl/prismic/utils';

export default function LockedContentModal({ sliceData }) {
  const currentUser = useCurrentUser();

  const modalData = sliceData.primary.modal_type.data;
  if (!modalData) {
    return null;
  }

  const permissionTypes = modalData.permission_types.map(
    type => type.permission_type
  );

  if (isAllowedAccess(currentUser, permissionTypes)) {
    return null;
  }

  return (
    <MiniOverlayModal hideCloseButton disableClose>
      <div
        className="PrismicLockedContentModal"
        data-test-id="prismic-locked-content-modal"
      >
        <div className="center ph20-md ph4 pv10 tc">
          <div className="PrismicLockedContentModal__logo stone-700 center pb8">
            <Logo />
          </div>
          {modalData.headline && (
            <p className="f5-md f4 fw-medium mb4">{modalData.headline}</p>
          )}
          {modalData.subcopy && <p className="mb8">{modalData.subcopy}</p>}
          {modalData.bullet_points[0] &&
            modalData.bullet_points[0].bullet_text && (
              <div className="mh10-md mb8">
                {modalData.bullet_points.map((point, idx) => (
                  <div className="mb6 fw-medium flex items-center" key={idx}>
                    <div>
                      <SmartImage
                        Tag="div"
                        width="32px"
                        height="32px"
                        className="gd-icon"
                        lazy
                        src={point.bullet_icon.url}
                        alt={point.bullet_text}
                      />
                    </div>
                    <p className="tl ml3-md ml2">{point.bullet_text}</p>
                  </div>
                ))}
              </div>
            )}
          {modalData.cta_copy && modalData.cta_link && (
            <a
              className="w-100 button button--primary"
              href={modalData.cta_link}
              rel="noopener noreferrer"
            >
              {modalData.cta_copy}
            </a>
          )}
        </div>
        {modalData.testimonial_quote && (
          <div className="bg-near-white ph14-md ph4 pv10 flex">
            {modalData.testimonial_profile_photo && (
              <SmartImage
                Tag="div"
                width="80px"
                height="80px"
                className="bg-center cover br-100"
                lazy
                src={modalData.testimonial_profile_photo.url}
                alt={modalData.testimonial_name}
              />
            )}
            <div className="pl7">
              <p className="i mb4">{modalData.testimonial_quote}</p>
              {modalData.testimonial_name && (
                <p className="fw-medium mb1">
                  &ndash; {modalData.testimonial_name}
                </p>
              )}
              {modalData.testimonial_bio && (
                <p className="f1 fw-medium">{modalData.testimonial_bio}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </MiniOverlayModal>
  );
}

LockedContentModal.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      modal_type: ModalPropTypes
    })
  }).isRequired
};
